import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetMeasurements = () => {
  return useQuery({
    queryKey: ["getMeasurements"],
    queryFn: async () => {
      const token = getToken();
      if (!token) throw new Error("No token found");

      const response = await axiosInstance.get("products/stocks/measurement", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    },
    enabled: !!getToken(),
  });
};
